var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unrestricted-input"},[_c('v-text-field',{ref:"typing-input",staticClass:"centered typing-input",attrs:{"spellcheck":"false","rounded":"","white":"","hide-details":"true","height":"100%"},on:{"input":_vm.handleInput},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }